<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input
        v-model="tableParams.ideaId"
        type="number"

        placeholder="创意id查询"
      />
      <search-dsp-select v-model="tableParams.dspId"/>
      <search-dsp-slot-select v-model="tableParams.dspSlotId" :dsp-id="tableParams.dspId"/>
      <el-select
        v-model="tableParams.ideaStatus"

        clearable
        placeholder="所有未删除创意"
        style="margin-right: 15px"
      >
        <el-option
          v-for="item in statusList"
          :label="item.lable"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <el-select
        v-model="tableParams.ideaType"

        clearable
        placeholder="所有形式创意"
        style="margin-right: 15px"
      >
        <el-option
          v-for="item in ideaTypeList"
          :label="item.lable"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <base-date-picker
        @changeDate="changeDate"
        style="margin-right: 15px; width: 250px"
      />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>
    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button @click="add" type="primary" size="small">新增创意</el-button>
      </table-column>
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <template v-if="v.field=== 'ideaType'">
              {{ ideaTypeMap[scope.row[v.field]] }}
            </template>
            <template v-else-if="v.field === 'ideaStatus'">
              <el-switch v-model="scope.row.ideaStatus" active-color="#13ce66" :active-value="1" :inactive-value="2" @change="upstate(scope.row)" />
            </template>
            <template v-else-if="v.field === 'landingPage' || v.field === 'dpAddress'">
              <div class="tab-editor">
                <el-tooltip effect="dark" :content="scope.row[v.field]" placement="top-start">
                  <div style="max-width: 500px;">
                    <span @click="handleCopy" >{{ scope.row[v.field] }}</span>
                  </div>
                </el-tooltip>
              </div>
            </template>
            <div v-else-if="v.field === 'imgUrls'" class="info">
                <div v-if="scope.row.imgUrls">
                  <div style="flex: 0 0 70px" title="素材预览" @click="handleInfo(scope.row[v.field],true)">
                    <img
                      :src="$imgURL + scope.row[v.field][0]"
                      v-if="scope.row[v.field].length > 0">
                  </div>
                </div>
                <div v-else>
                  <div style="flex: 0 0 70px" title="素材预览" @click="handleInfo(scope.row['linkUrls'],false)">
                    <img
                      :src="scope.row['linkUrls'][0]"
                      v-if="scope.row['linkUrls'].length > 0">
                  </div>
                </div>
              <div style="display: block;flex: 1;margin-left: 10px;;overflow: hidden;" title="点击查看" @click="open(scope.row)">
                <div style="justify-content: left;font-size: 14px;">{{ scope.row.ideaTitle }}</div>
                <div style="justify-content: left">{{ scope.row.ideaDesc }}</div>
              </div>
            </div>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope" align="center">
            <el-button @click="updata(scope.row)" type="success" size="mini"
            >修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <div v-if="imgOrVideoShow" style="position: relative;z-index: 1;">
      <img-or-video
        :imgList="imgList"
        :videoList="videoList"
        :domain-flag="domainFlag"
        @close="imgClose"/>
    </div>
    <m-form ref="form" @submit="renew"></m-form>
  </div>
</template>

<script>
import initTableMixin from '@/mixins/initTable'
import BaseDatePicker from '@/components/BaseDatePicker'
import ImgOrVideo from '@/components/ImgOrVideo'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import { downExcelMixin } from '@/mixins/downExcel'
import TableColumn from '@/components/TableColumn'
import mForm from './form.vue'
import { upstataCreative, getTemplate } from '@/api/manage/creative/creative'
import { ideaTypeList, ideaTypeMap } from '@/const/idea-type'
import * as domain from 'domain'

export default {
  name: 'managerCreative',
  computed: {
    domain () {
      return domain
    }
  },
  mixins: [initTableMixin, downExcelMixin],
  components: {
    BaseDatePicker,
    TableColumn,
    SearchDspSlotSelect,
    SearchDspSelect,
    mForm,
    ImgOrVideo
  },
  data () {
    return {
      statusList: [
        { value: 1, lable: '开启' },
        { value: 2, lable: '暂停' },
        { value: 3, lable: '删除' }
      ],
      ideaTypeList,
      ideaTypeMap,
      template: [],
      columns: [
        { field: 'ideaStatus', title: '创意状态' },
        { field: 'ideaId', title: '创意ID' },
        { field: 'dspName', title: 'dsp名称' },
        { field: 'dspSlotName', title: 'dsp广告位' },
        { field: 'imgUrls', title: '创意预览', width: '200px' },
        { field: 'ideaType', title: '创意类型' },
        { field: 'landingPage', title: '落地页', width: '100px' },
        { field: 'dpAddress', title: 'DP地址', width: '100px' },
        { field: 'showSmt', title: '展示次数' },
        { field: 'clkSmt', title: '点击次数' },
        { field: 'clkSmtRate', title: '点击率' },
        { field: 'dpSmt', title: '唤醒数' },
        { field: 'dpSmtRate', title: '唤醒率' },
        { field: 'createTime', title: '创建时间' }
      ],
      // 图片和视频浏览
      imgList: [],
      videoList: [],
      imgOrVideoShow: false,
      domainFlag: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  created () {
    getTemplate().then((res) => {
      this.template = res.data
    })
  },
  methods: {
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    beforeInit () {
      this.tableUrl = '/webIdea/list'
      return true
    },
    add () {
      this.$refs.form.show()
    },
    updata (row) {
      this.$refs.form.show(row)
    },
    upstate (row) {
      const state = {
        ideaId: row.ideaId,
        ideaStatus: row.ideaStatus
      }
      upstataCreative(state)
    },
    renew () {
      this.currentChange(this.pagination.pageNum)
    },
    // 点击复制
    handleCopy (e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    },
    // 查看描述
    open (item) {
      if (item.ideaTitle || item.ideaDesc) {
        this.$alert(`
        <div>${item.ideaTitle}</div>
        <div>${item.ideaDesc}</div>
        `, item.title, {
          dangerouslyUseHTMLString: true
        })
      }
    },
    handleInfo (info, domainFlag) {
      this.imgList = []
      this.domainFlag = domainFlag
      this.imgList = info.filter(item => {
        return item !== ''
      })

      this.imgOrVideoShow = true
    },
    imgClose () {
      this.imgOrVideoShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select & > .base-date-picker {
    width: 400px;
  }

  & > .el-input {
    width: 220px;
  }
}
.tab-editor {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.info {
  display: flex;
  padding: 10px 0 10px 0;
  width: 100%;
  img,video{
    width: 70px;
    height: 70px;
    border-radius: 4px;
    margin-right: 5px;
    border: 1px solid #ddd;
  }
  white-space:nowrap;
  cursor: pointer;
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;

}
</style>
